/* global d3 */
import util from './_utils';
import topojson from 'topojson';
import core_viz from './core-viz';

const container = d3.select('.graphic__chart'),
	svg = container.select('.svg__health'),
	svg_lh = container.select('.svg__love-hate'),
	copy_panel = d3.select('.graphic__right.health'),
	header = d3.select('.wwr-header'),
	bottom_panel = container.select('.bottom__panel'),
	bottom_panel_health = bottom_panel.select('.bottom__panel-health');

let mapJson = null,
	scaleDivisor = 500,
	scale = null,
	projection = null,
	rotate = [0, 0],
	path = null,
	globeOutline = null,
	countryLines = null,
	globeTimer = null,
	zoomTimeout = null,
	rotateTimeout = null,
	transition = null,
	isMobile = null;

let step = 0;

let vizParameters = null;

const countryScales = {
	'Japan': 1.2,
	'United States of America': 1.5,
	'Germany': 1.2,
	'Brazil': 1.6,
}

function resize() {
	setup();
}

function init() {
	svg.style('pointer-events', 'none');
	return new Promise((resolve, reject) => {
		Promise.all([
			d3.json('assets/data/world-countries.json'),
		]).then(function(files) {
			mapJson = files[0];
			setup();
			click();
			resolve();
		}).catch(function(err) {
			console.log(err);
		})
	})
}

function next(index) {
	step = index + 1;
	if (step === 0) reset();
	if (step === 1) flyToCountry('Brazil');
	if (step === 2) flyToCountry('Germany');
	if (step === 3) flyToCountry('United States of America');
	if (step === 4) flyToCountry('Japan');
}

function setup(build = false) {
	if (build) {
		scaleDivisor = 500,
			rotate = [0, 0];
	}

	vizParameters = getVizParameters();

	scale = Math.min(vizParameters.width, vizParameters.height) / scaleDivisor; // scale globe

	// map projection
	projection = d3.geoOrthographic()
		.scale(scale)
		.rotate(rotate)
		.translate([vizParameters.centerX, vizParameters.centerY]);

	// path generator
	path = d3.geoPath()
		.projection(projection);

	if (build) drawGlobe();
}

function click() {
	bottom_panel_health.selectAll('.bottom__panel-clickable')
		.on('click', function() {
			const country = d3.select(this).attr('data-country');

			if (country === 'Brazil') util.skipStep(0)
			if (country === 'Germany') util.skipStep(1)
			if (country === 'United States of America') util.skipStep(2)
			if (country === 'Japan') util.skipStep(3)
		})
}

function drawGlobe(duration = 1000) {
	svg.style('pointer-events', 'all');
	/*
	core_viz.massMouseoverOn(false);
	core_viz.stopSimulation();

	container.selectAll('.cv-question-label')
		.transition()
		.duration(200)
		.style('opacity', 0)
		.remove();

	svg_lh.selectAll('.bubble')
		.filter((d, i) => i !== 1)
		.transition()
		.delay((d, i) => i * .2)
		.duration(duration)
		.attr('cx', d => {
			const currentX = d.x;
			if (d.x > vizParameters.width / 2) return vizParameters.width + 200 + (Math.random() * 100);
			return -200 - (Math.random() * 100)
		})
		.transition()
		.duration(0)
		.style('visibility', 'hidden');

	svg_lh.selectAll('.bubble')
		.filter((d, i) => i === 1)
		.style('fill', '#242428')
		.style('stroke', '#717171')
		.style('stroke-width', '1')
		.transition()
		.duration(duration + 1000)
		.attr('cx', vizParameters.centerX)
		.attr('cy', vizParameters.centerY)
		.attr('r', projection.scale());
	*/

	globeOutline = svg.append('circle')
		.attr('cx', vizParameters.centerX)
		.attr('cy', vizParameters.centerY)
		.attr('r', projection.scale())
		.style('fill', '#242428')
		.style('stroke', '#717171')
		.style('stroke-width', '1')
	//.style('opacity', 0)

	/*
	globeOutline.transition()
		.delay(duration + 1000)
		.duration(0)
		.style('opacity', 1)
	//.attr('filter', 'url(#glow)');
		*/

	countryLines = svg.selectAll('.country-line')
		.data(mapJson.features)
		.enter()
		.append('path')
		.attr('d', path)
		.classed('country-line', true)
		//.attr("clip-path", "url(#ellipse-clip)")
		.style('fill', d => {
			const highlightedCountries = Object.keys(countryScales);
			return highlightedCountries.indexOf(d.properties.name) > -1 ? '#F8621F' : '#242428';
		})
		.style('stroke', '#717171')
		.style('stroke-width', '.5')
		.style('opacity', 0)

	countryLines.transition()
		.delay(0)
		.duration(0)
		.style('opacity', 1)

	zoomTimeout = setTimeout(function() {
		bigZoom();
	}, 1000);

	rotateTimeout = setTimeout(function() {
		rotateMap();
	}, 2000);

}

function rebuild() {
	globeOutline.attr('cx', vizParameters.centerX)
		.attr('cy', vizParameters.centerY)
		.attr('r', projection.scale())

	countryLines.attr('d', path);
}

function clear() {
	if (globeTimer) globeTimer.stop();
	//if (transition) transition.transition();
	clearTimeout(zoomTimeout);
	clearTimeout(rotateTimeout);

	svg.style('pointer-events', 'none');
	svg.selectAll('*').remove();

	updateBottomPanel('');
}

function bigZoom(speed = 1000) {
	transition = d3.transition()
		.duration(speed)
		.tween('zoom', function() {
			const scaleTween = d3.interpolate(projection.scale(), Math.min(vizParameters.width, vizParameters.height) / 2.5);

			return function(t) {
				projection.scale(scaleTween(t))
				countryLines.attr('d', path);
				globeOutline.attr('r', scaleTween(t));
				scaleDivisor = getScaleDivisor(scaleTween(t));
			};
		})
}

function rotateMap() {
	const tRotation = 30000; //30s per rotation

	let tNew, dt, steps, pos, tOld, oldPos;
	tOld = 0;
	oldPos = rotate[0];

	globeTimer = d3.timer(myTimer);

	function myTimer(now) {
		tNew = now;
		dt = tOld - tNew;
		steps = dt * 360 / tRotation;

		pos = oldPos - steps;

		if (pos <= -180) {
			pos = pos + 360
		}

		projection.rotate([pos, 0])
		rotate = [pos, 0];
		countryLines.attr('d', path)

		tOld = tNew;
		oldPos = pos;
	};
}

function reset(speed = 2500) {
	transition = d3.transition()
		.duration(speed)
		.tween('reset', function() {
			var rotateTween = d3.interpolate(projection.rotate(), [0, 0]);
			var scaleTween = d3.interpolate(projection.scale(), Math.min(vizParameters.width, vizParameters.height) / 2.5);

			return function(t) {
				projection.rotate(rotateTween(t)).scale(scaleTween(t))
				rotate = rotateTween(t);
				countryLines.attr('d', path);
				globeOutline.attr('r', scaleTween(t));
				scaleDivisor = getScaleDivisor(scaleTween(t));
			};
		})
		.on('end', function() {
			rotateMap();
		})

	highlightCountry(Object.keys(countryScales));
	updateBottomPanel('');
	//rotateMap()
}

function flyToCountry(country, speed = 2500) {
	if (globeTimer) globeTimer.stop();
	clearTimeout(zoomTimeout);
	clearTimeout(rotateTimeout);

	const countryFeature = mapJson.features.filter(d => d.properties.name === country)[0];
	const coords = d3.geoCentroid(countryFeature);

	transition = d3.transition()
		.duration(speed)
		.tween('fly', function() {
			var rotateTween = d3.interpolate(projection.rotate(), [-coords[0], -coords[1]]);
			var scaleTween = d3.interpolate(projection.scale(), Math.min(vizParameters.width, vizParameters.height) / countryScales[country]);

			return function(t) {
				projection.rotate(rotateTween(t)).scale(scaleTween(t))
				rotate = rotateTween(t);
				countryLines.attr('d', path)
				globeOutline.attr('r', scaleTween(t));
				scaleDivisor = getScaleDivisor(scaleTween(t));
			};
		})

	updateBottomPanel(country);
	highlightCountry([country]);
}

function highlightCountry(countries) {
	svg.selectAll('path')
		.transition()
		.duration(1000)
		.style('fill', d => {
			return countries.indexOf(d.properties.name) > -1 ? '#f86214' : '#242428'
		})
}

function updateBottomPanel(country) {
	bottom_panel_health.selectAll('h5')
		.classed('is-active', function() {
			return d3.select(this).attr('data-country') === country;
		});
}

function getVizParameters() {
	isMobile = util.isMobile();

	const parameters = {};

	const container_width = container.node().offsetWidth,
		container_height = container.node().offsetHeight,
		header_height = header.node().offsetHeight,
		copy_panel_width = copy_panel.node().offsetWidth,
		copy_panel_height = copy_panel.node().offsetHeight,
		bottom_panel_height = bottom_panel.node().offsetHeight,
		bottom_panel_health_height = bottom_panel_health.node().offsetHeight + 20;

	parameters.yOffset = header_height,
		parameters.fullWidth = container_width,
		parameters.fullHeight = container_height - bottom_panel_height - bottom_panel_health_height - parameters.yOffset,
		parameters.fullCenterX = parameters.fullWidth / 2,
		parameters.fullCenterY = parameters.fullHeight / 2 + parameters.yOffset,
		parameters.fullBottomY = container_height + container_height * .1;

	if (!isMobile) {
		const adjusted_width = container_width - copy_panel_width;

		parameters.width = adjusted_width,
			parameters.height = parameters.fullHeight;

		parameters.centerX = adjusted_width / 2,
			parameters.centerY = parameters.fullCenterY;

	} else {
		// const adjusted_height = container_height - header_height - copy_panel_height;
		const adjusted_height = container_height / 2 - header_height;

		parameters.width = parameters.fullWidth,
			parameters.height = adjusted_height;

		parameters.centerX = parameters.fullCenterX,
			parameters.centerY = (adjusted_height / 2) + header_height;
	}

	return parameters;
}

function getBottomPanelHeight() {
	const bottom_panel_height = bottom_panel.node().offsetHeight;

	bottom_panel_health.style('display', 'flex');
	const bottom_panel_health_height = bottom_panel_health.node().offsetHeight + 10;
	bottom_panel_health.style('display', '');

	return bottom_panel_height + bottom_panel_health_height;
}

function getScaleDivisor(s) {
	return Math.min(vizParameters.width, vizParameters.height) / s;
}

export default {
	init,
	resize,
	setup,
	rebuild,
	drawGlobe,
	next,
	clear,
};